"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductMethods = exports.Product = void 0;

var _moment = _interopRequireDefault(require("moment"));

var _numbers = require("../utils/numbers");

var _strings = require("../utils/strings");

var _excluded = ["product_id", "product_name", "product_sku", "product_price", "product_region_links", "product_stock"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var ProductMethods = /*#__PURE__*/function () {
  function ProductMethods() {
    _classCallCheck(this, ProductMethods);
  }

  _createClass(ProductMethods, null, [{
    key: "getName",
    value: function getName(product) {
      return (0, _strings.decodeUTF8)(product.name);
    }
  }, {
    key: "getPhotoUrl",
    value: function getPhotoUrl(product) {
      var photoUrl = product.product_photo_thumb || product.product_photo || product.product_photo_thumb_square || product.image_thumb || product.image_thumb_square || ''; // We were encoding manually added products at some point so just in case

      return (0, _strings.decodeUTF8)(photoUrl);
    }
  }, {
    key: "getFormattedPrice",
    value: function getFormattedPrice(product) {
      var _product$currency;

      return (0, _numbers.priceWithCurrency)(product.price, (_product$currency = product.currency) === null || _product$currency === void 0 ? void 0 : _product$currency.toUpperCase());
    }
  }, {
    key: "getBuyNowLinkUrl",
    value: function getBuyNowLinkUrl(product) {
      return (0, _strings.decodeUTF8)(product.buy_now_link_url);
    }
    /**
      * Returns an object {optionName: [optionValues]} of all the possible options found in the product variants.
      * Not all options combinations actually correspond to a variant.
      * For example, given 2 options: Color: [Red, Blue] and Size: [S, M], and 2 variants: [Red/S, Blue/M], we see that Red/M and Blue/S are not possible.
      * In this example, this will return all possible options: {Color: [Red, Blue], Size: [S, M]}.
      */

  }, {
    key: "getAvailableOptions",
    value: function getAvailableOptions(product) {
      var _product$variants_jso;

      return Object.keys((_product$variants_jso = product.variants_json) !== null && _product$variants_jso !== void 0 ? _product$variants_jso : {}).reduce(function (result, variantId) {
        var _product$variants_jso2;

        var variant_options = ProductMethods.getVariantOptions((_product$variants_jso2 = product.variants_json) === null || _product$variants_jso2 === void 0 ? void 0 : _product$variants_jso2[variantId]);

        if (variant_options) {
          Object.keys(variant_options).forEach(function (optionName) {
            if (!result[optionName]) {
              result[optionName] = [];
            }

            result[optionName].push(variant_options[optionName]); // Remove duplicates

            result[optionName] = Array.from(new Set(result[optionName]));
          });
        }

        return result;
      }, {});
    }
    /**
       * Returns the variant records that match the options passed as parameters
       * For example, given 2 options: Color: [Red, Blue] and Size: [S, M], and 2 variants: [Red/S, Blue/M].
       * If options={Color:Red, Size:S}, it will return the variant record for Red/S.
       */

  }, {
    key: "getVariantsFromOptions",
    value: function getVariantsFromOptions(product, options) {
      var _product$variants_jso3;

      var variantIds = Object.keys((_product$variants_jso3 = product.variants_json) !== null && _product$variants_jso3 !== void 0 ? _product$variants_jso3 : {}).filter(function (variantId) {
        return Object.keys(options !== null && options !== void 0 ? options : {}).every(function (optionName) {
          var _product$variants_jso4;

          var expectedValue = options[optionName];
          var variant_options = ProductMethods.getVariantOptions((_product$variants_jso4 = product.variants_json) === null || _product$variants_jso4 === void 0 ? void 0 : _product$variants_jso4[variantId]);
          return (variant_options === null || variant_options === void 0 ? void 0 : variant_options[optionName]) === expectedValue;
        });
      });
      return variantIds.map(function (variantId) {
        var _product$variants_jso5;

        var variant = (_product$variants_jso5 = product.variants_json) === null || _product$variants_jso5 === void 0 ? void 0 : _product$variants_jso5[variantId];
        return _objectSpread({
          id: variantId
        }, _typeof(variant) === 'object' ? variant : {});
      });
    }
  }, {
    key: "isOptionCombinationPossible",
    value: function isOptionCombinationPossible(product, options) {
      return ProductMethods.getVariantsFromOptions(product, options).length > 0;
    }
  }, {
    key: "getVariantPhotoUrl",
    value: function getVariantPhotoUrl(product, options) {
      var _variants$, _variants$2;

      var variants = ProductMethods.getVariantsFromOptions(product, options);
      return variants.length === 1 && typeof ((_variants$ = variants[0]) === null || _variants$ === void 0 ? void 0 : _variants$.variant_image_src) === 'string' ? (_variants$2 = variants[0]) === null || _variants$2 === void 0 ? void 0 : _variants$2.variant_image_src : null;
    }
  }, {
    key: "getVariantFormattedPrice",
    value: function getVariantFormattedPrice(product, options) {
      var _product$currency2;

      var variants = ProductMethods.getVariantsFromOptions(product, options);

      if (variants.length !== 1) {
        return null;
      }

      var priceNum = ProductMethods.getVariantPrice(variants[0]);
      return (0, _numbers.priceWithCurrency)(priceNum, (_product$currency2 = product.currency) === null || _product$currency2 === void 0 ? void 0 : _product$currency2.toUpperCase());
    }
  }, {
    key: "getVariantId",
    value: function getVariantId(product, options) {
      var variants = ProductMethods.getVariantsFromOptions(product, options);

      if (!variants.length) {
        return null;
      }

      return variants[0] && _typeof(variants[0]) === 'object' && 'id' in variants[0] && typeof variants[0].id === 'string' ? variants[0].id : null;
    }
  }, {
    key: "getUpdatedAtMoment",
    value: function getUpdatedAtMoment(product) {
      return (0, _moment["default"])(product.updated_at);
    }
  }, {
    key: "getVariantPrice",
    value: function getVariantPrice(variant) {
      return variant && _typeof(variant) === 'object' && 'variant_price' in variant && ['string', 'number'].includes(_typeof(variant.variant_price)) ? Number(variant.variant_price) : undefined;
    }
  }, {
    key: "getVariantImgSrc",
    value: function getVariantImgSrc(variant) {
      return variant && _typeof(variant) === 'object' && 'variant_image_src' in variant && typeof variant.variant_image_src === 'string' ? variant.variant_image_src : undefined;
    }
  }, {
    key: "getVariantTitle",
    value: function getVariantTitle(variant) {
      return variant && _typeof(variant) === 'object' && 'variant_title' in variant && typeof variant.variant_title === 'string' ? variant.variant_title : undefined;
    }
  }, {
    key: "getVariantOptions",
    value: function getVariantOptions(variant) {
      return variant && _typeof(variant) === 'object' && 'variant_options' in variant && _typeof(variant.variant_options) === 'object' && variant.variant_options ? variant.variant_options : undefined;
    }
  }, {
    key: "getVariantStock",
    value: function getVariantStock(variant) {
      return variant && _typeof(variant) === 'object' && 'variant_stock' in variant && ['string', 'number'].includes(_typeof(variant.variant_stock)) ? Number(variant.variant_stock) : undefined;
    }
  }, {
    key: "getVariantSku",
    value: function getVariantSku(variant) {
      return variant && _typeof(variant) === 'object' && 'variant_sku' in variant && typeof variant.variant_sku === 'string' ? variant.variant_sku : undefined;
    }
  }, {
    key: "getVariantUpc",
    value: function getVariantUpc(variant) {
      return variant && _typeof(variant) === 'object' && 'variant_upc' in variant && typeof variant.variant_upc === 'string' ? variant.variant_upc : undefined;
    }
  }, {
    key: "getVariant",
    value: function getVariant(product, variantId) {
      var _product$variants_jso6;

      var variant = (_product$variants_jso6 = product.variants_json) === null || _product$variants_jso6 === void 0 ? void 0 : _product$variants_jso6[variantId];
      return variant ? {
        variant_id: variantId,
        variant_price: ProductMethods.getVariantPrice(variant),
        variant_image_src: ProductMethods.getVariantImgSrc(variant),
        variant_title: ProductMethods.getVariantTitle(variant),
        variant_options: ProductMethods.getVariantOptions(variant),
        variant_stock: ProductMethods.getVariantStock(variant),
        variant_sku: ProductMethods.getVariantSku(variant),
        variant_upc: ProductMethods.getVariantUpc(variant)
      } : undefined;
    }
  }, {
    key: "isInStock",
    value: function isInStock(product) {
      var _product$region_links;

      if (!((_product$region_links = product.region_links) !== null && _product$region_links !== void 0 && _product$region_links.length)) {
        return !!product.stock;
      }

      return product.region_links.some(function (link) {
        return !!link.stock;
      });
    }
  }]);

  return ProductMethods;
}();
/**
 * @deprecated - use the product methods instead
 */


exports.ProductMethods = ProductMethods;

/**
 * @deprecated - use the product methods instead
 */
var Product = /*#__PURE__*/function () {
  function Product(data) {
    _classCallCheck(this, Product);

    _defineProperty(this, "variants_json", {});

    Object.assign(this, data);
  }

  _createClass(Product, [{
    key: "getName",
    value: function getName() {
      return (0, _strings.decodeUTF8)(this.name);
    }
  }, {
    key: "getPhotoUrl",
    value: function getPhotoUrl() {
      var photoUrl = this.product_photo_thumb || this.product_photo || this.product_photo_thumb_square || this.image_thumb || this.image_thumb_square || ''; // We were encoding manually added products at some point so just in case

      return (0, _strings.decodeUTF8)(photoUrl);
    }
  }, {
    key: "getFormattedPrice",
    value: function getFormattedPrice() {
      var _this$currency;

      return (0, _numbers.priceWithCurrency)(this.price, (_this$currency = this.currency) === null || _this$currency === void 0 ? void 0 : _this$currency.toUpperCase());
    }
  }, {
    key: "getBuyNowLinkUrl",
    value: function getBuyNowLinkUrl() {
      return (0, _strings.decodeUTF8)(this.buy_now_link_url);
    }
    /**
    * Returns an object {optionName: [optionValues]} of all the possible options found in the product variants.
    * Not all options combinations actually correspond to a variant.
    * For example, given 2 options: Color: [Red, Blue] and Size: [S, M], and 2 variants: [Red/S, Blue/M], we see that Red/M and Blue/S are not possible.
    * In this example, this will return all possible options: {Color: [Red, Blue], Size: [S, M]}.
    */

  }, {
    key: "getAvailableOptions",
    value: function getAvailableOptions() {
      var _this$variants_json,
          _this = this;

      return Object.keys((_this$variants_json = this.variants_json) !== null && _this$variants_json !== void 0 ? _this$variants_json : {}).reduce(function (result, variantId) {
        var _this$variants_json$v, _this$variants_json2, _this$variants_json2$;

        Object.keys((_this$variants_json$v = (_this$variants_json2 = _this.variants_json) === null || _this$variants_json2 === void 0 ? void 0 : (_this$variants_json2$ = _this$variants_json2[variantId]) === null || _this$variants_json2$ === void 0 ? void 0 : _this$variants_json2$.variant_options) !== null && _this$variants_json$v !== void 0 ? _this$variants_json$v : {}).forEach(function (optionName) {
          var _this$variants_json3, _this$variants_json3$, _this$variants_json3$2;

          if (!result[optionName]) {
            result[optionName] = [];
          }

          result[optionName].push((_this$variants_json3 = _this.variants_json) === null || _this$variants_json3 === void 0 ? void 0 : (_this$variants_json3$ = _this$variants_json3[variantId]) === null || _this$variants_json3$ === void 0 ? void 0 : (_this$variants_json3$2 = _this$variants_json3$.variant_options) === null || _this$variants_json3$2 === void 0 ? void 0 : _this$variants_json3$2[optionName]); // Remove duplicates

          result[optionName] = Array.from(new Set(result[optionName]));
        });
        return result;
      }, {});
    }
    /**
     * Returns the variant records that match the options passed as parameters
     * For example, given 2 options: Color: [Red, Blue] and Size: [S, M], and 2 variants: [Red/S, Blue/M].
     * If options={Color:Red, Size:S}, it will return the variant record for Red/S.
     */

  }, {
    key: "getVariantsFromOptions",
    value: function getVariantsFromOptions(options) {
      var _this$variants_json4;

      var variants = Object.entries((_this$variants_json4 = this.variants_json) !== null && _this$variants_json4 !== void 0 ? _this$variants_json4 : {}).filter(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            _ = _ref2[0],
            variantData = _ref2[1];

        return Object.keys(options !== null && options !== void 0 ? options : {}).every(function (optionName) {
          var _variantData$variant_;

          var expectedValue = options[optionName];
          return ((_variantData$variant_ = variantData.variant_options) === null || _variantData$variant_ === void 0 ? void 0 : _variantData$variant_[optionName]) === expectedValue;
        });
      });
      return variants.map(function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
            variantId = _ref4[0],
            variantData = _ref4[1];

        return _objectSpread({
          id: variantId
        }, variantData);
      });
    }
  }, {
    key: "isOptionCombinationPossible",
    value: function isOptionCombinationPossible(options) {
      return this.getVariantsFromOptions(options).length > 0;
    }
  }, {
    key: "isInStock",
    value: function isInStock() {
      var _this$region_links;

      if (!((_this$region_links = this.region_links) !== null && _this$region_links !== void 0 && _this$region_links.length)) {
        return !!this.stock;
      }

      return this.region_links.some(function (link) {
        return !!link.stock;
      });
    }
  }, {
    key: "getVariantPhotoUrl",
    value: function getVariantPhotoUrl(options) {
      var _variants$3;

      var variants = this.getVariantsFromOptions(options);
      return variants.length === 1 ? (_variants$3 = variants[0]) === null || _variants$3 === void 0 ? void 0 : _variants$3.variant_image_src : null;
    }
  }, {
    key: "getVariantFormattedPrice",
    value: function getVariantFormattedPrice(options) {
      var _variants$4, _this$currency2;

      var variants = this.getVariantsFromOptions(options);

      if (variants.length !== 1) {
        return null;
      }

      var price = (_variants$4 = variants[0]) === null || _variants$4 === void 0 ? void 0 : _variants$4.variant_price;
      return (0, _numbers.priceWithCurrency)(price, (_this$currency2 = this.currency) === null || _this$currency2 === void 0 ? void 0 : _this$currency2.toUpperCase());
    }
  }, {
    key: "getVariantId",
    value: function getVariantId(options) {
      var _variants$5;

      var variants = this.getVariantsFromOptions(options);
      return variants.length === 1 ? (_variants$5 = variants[0]) === null || _variants$5 === void 0 ? void 0 : _variants$5.id : null;
    }
  }, {
    key: "getUpdatedAtMoment",
    value: function getUpdatedAtMoment() {
      return (0, _moment["default"])(this.updated_at);
    }
  }], [{
    key: "fromProductListResponse",
    value: function fromProductListResponse(p) {
      // Differences between AlbumProduct and Product:
      //  - AlbumProduct has 'product_id', 'product_name', 'product_sku', 'product_price', and 'product_region_links' instead of 'id', 'name', 'sku', 'price',  and 'region_links'
      var product_id = p.product_id,
          product_name = p.product_name,
          product_sku = p.product_sku,
          product_price = p.product_price,
          product_region_links = p.product_region_links,
          product_stock = p.product_stock,
          rest = _objectWithoutProperties(p, _excluded);

      return new Product(_objectSpread(_objectSpread({}, rest), {}, {
        id: product_id,
        name: product_name,
        sku: product_sku,
        price: product_price,
        region_links: product_region_links,
        stock: product_stock
      }));
    }
  }]);

  return Product;
}();

exports.Product = Product;